// Angular modules
import { HttpClient }         from '@angular/common/http';
import { HttpHeaders }        from '@angular/common/http';
import { Injectable }         from '@angular/core';

// External modules
import { ApplicationService } from './application-service';
import { AuthService }        from './auth-service';
import { Observable }         from 'rxjs/Rx';
import 'rxjs/add/operator/map'                               ;

// Internal modules
import { environment }        from '../../../environments/environment';

// Interfaces
import { Document }           from '../interfaces/document.interface';

// Helpers
import { StorageHelper }      from '../helpers/storage.helper';

@Injectable()
export class DocumentService
{

  constructor(public http               : HttpClient,
              public applicationService : ApplicationService,
              public authService        : AuthService)
  {

  }

  async hasDocumentUpdate(): Promise<boolean>
  {
    const localDocument = StorageHelper.getDocument();
    if(localDocument == null)
    {
      console.log("no document found..");
      return false;
    }

    const remoteDocument = await this.requestDocumentVersion();
    if(localDocument.Updated == remoteDocument.Updated)
    {
      console.log("no updates needed..")
      return false;
    }

    console.log("Updates are needed..")
    return true;
  }

  requestDocumentVersion(): Promise<Document>
  {
      let headers    = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept' : 'application/json', 'apiKey' : environment.API_KEY });
      let options    = { headers: headers, withCredentials: true };

      return this.http.get<Document>(environment.API_ENDPOINT + '/activeDocument', options)
      .catch((error: any) => Observable.throw('Please check your internet connection'))
      .toPromise();;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/document-service.ts